import { Primitive } from '@sentry/core';
import { getGlobalScope } from '@sentry/react';
import { jwtDecode } from 'jwt-decode';
import React, { Fragment, useEffect } from 'react';

import { authService } from 'src/services/auth';
import { useSelector } from 'src/store';

function useTagValue(value: Primitive, key: string) {
    useEffect(() => {
        if (value) {
            getGlobalScope().setTag(key, value);
        }
    }, [value, key]);
}

export function SentryTagger() {
    const { clinicId, appointmentTypeId, doctorErpId, dateTime } = useSelector((state) => state.appointment);
    const { customerId } = useSelector((state) => state.customer);

    useTagValue(clinicId, 'clinic_id');
    useTagValue(appointmentTypeId, 'appointment_type_id');
    useTagValue(doctorErpId, 'provider_id');
    useTagValue(dateTime, 'appointment_time');
    useTagValue(customerId, 'customer_id');

    useTagValue(
        authService.Token?.jwt && jwtDecode<Record<string, string>>(authService.Token.jwt)?.['bpPatientId'],
        'patient_id'
    );

    return <Fragment />;
}
